import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { TextField, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { MenuItem, Select, FormControl, InputLabel, Paper, CircularProgress, IconButton, Tooltip, Stack, Box } from "@mui/material";
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import SaveIcon from '@mui/icons-material/Save';
import PopupNotification from './PopupNotification';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNotification } from './context/NotificationContext';

function ImeiConfig() {
    const { showNotification } = useNotification();
    const [data, setData] = useState({ enable: 0, time: 0, dataList: [] });
    const [defaultIp, setDefaultIp] = useState('10.147.19.123');
    const [ip, setIp] = useState(localStorage.getItem('ip') || defaultIp);
    const [isLoading, setIsLoading] = useState(true);
    const [availablePcs, setAvailablePcs] = useState([]);
    const [dataz, setDataz] = useState([]);
    const [editedData, setEditedData] = useState({});
    const [loading, setLoading] = useState(false);
    const [showPopup, setShowPopup] = useState(false);
    const [fadeOut, setFadeOut] = useState(false);
    const [popupMessage, setPopupMessage] = useState('');
    const accessToken = 'uBEiuHBXrDfiuthssKUQFN4xyJzmWPj3';
    const [sortColumn, setSortColumn] = useState(null);
    const [sortOrder, setSortOrder] = useState('asc'); // 'asc' or 'desc'
    const getSortedData = () => {
        let sorted = [...dataz];
        if (sortColumn === 'slot') {
            sorted.sort((a, b) => {
                const slotA = slotsData.find(slotItem => slotItem.port === a.port)?.slotId || Infinity;
                const slotB = slotsData.find(slotItem => slotItem.port === b.port)?.slotId || Infinity;
                return (sortOrder === 'asc' ? 1 : -1) * (slotA - slotB);
            });
        } else if (sortColumn === 'port') {
            sorted.sort((a, b) => {
                return (sortOrder === 'asc' ? 1 : -1) * (a.port - b.port);
            });
        }
        return sorted;
    };


    const handleSortToggle = (column) => {
        if (sortColumn === column) {
            setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
        } else {
            setSortColumn(column);
            setSortOrder('asc');
        }
    };



    useEffect(() => {
        fetch("https://frek.cc/proxy/38.54.86.24:5000/expiry/1000")
            .then((response) => response.json())
            .then((data) => {
                if (data[0] && data[0].value) {
                    const pcValues = data[0].value.split(",").map(Number);
                    setAvailablePcs(pcValues);

                    if (!localStorage.getItem('ip')) {
                        const defaultIpNumber = pcValues[0] + 100;
                        const newDefaultIp = `10.147.19.${defaultIpNumber}`;
                        setDefaultIp(newDefaultIp);
                        setIp(newDefaultIp);
                        localStorage.setItem('ip', newDefaultIp);
                    }
                }
                setIsLoading(false);
            })
            .catch((error) => {
                console.error("Error fetching PC numbers:", error);
                setIsLoading(false);
            });
    }, []);


    const handleChangeIp = (event) => {
      setIp(event.target.value);
      localStorage.setItem('ip', event.target.value);
      window.location.reload();
    }
  
    function getPcNumberFromIp(ip) {
      let parts = ip.split('.');
      let lastPart = Number(parts[parts.length - 1]);
      return lastPart - 100;
    }
  
  
    const generateIpOptions = () => {
      const ipOptions = [];
  
      for (let i = 100; i <= 123; i++) {
        const ipAddress = `10.147.19.${i}`;
        const pcNumber = i - 100;
        const pcName = `PC${pcNumber.toString().padStart(2, '0')}`; // Pad with zero for consistency
  
        // Check if PC number is in the available list, or is PC00 or PC23
        const isDisabled = pcNumber !== 0 && pcNumber !== 23 && !availablePcs.includes(pcNumber);
  
        ipOptions.push(
          <MenuItem value={ipAddress} key={ipAddress} disabled={isDisabled}>
            {pcName}
          </MenuItem>
        );
      }
  
      return ipOptions;
    };



    useEffect(() => {
        document.title = `Imei Config`;
    }, []);

    // Define fetchData outside of useEffect
    const fetchData = async () => {
        try {
            const result = await axios({
                method: 'post',
                url: `https://frek.cc/proxy/${ip}:8851/setting/getImeiPage`,
                headers: { "x-access-token": accessToken },
                data: { pageSize: 1, size: 200 }
            });

            setDataz(result.data.data.data);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    useEffect(() => {
        const fetchDataAndUpdateSlots = async () => {
            await fetchData();
            const slotsData = await fetchSlotsData(ip, accessToken);
            setSlotsData(slotsData);
        };

        // Fetch immediately on mount
        fetchDataAndUpdateSlots();

        // Set interval for fetching data every 5 seconds
        const intervalId = setInterval(fetchDataAndUpdateSlots, 5000);

        // Cleanup the interval on component unmount
        return () => clearInterval(intervalId);
    }, [ip, accessToken]);




    const handleChangeIMEI = (index, event) => {
        setEditedData({
            ...editedData,
            [index]: { port: dataz[index].port, imei: event.target.value },
        });
    };

    const handleSubmitz = async () => {
        try {
            setLoading(true);
            const result = await axios({
                method: 'post',
                url: `https://frek.cc/proxy/${ip}:8851/setting/saveImei`,
                headers: { "x-access-token": accessToken },
                data: { dataList: Object.values(editedData) }
            });

            if (result.data.result) {

            } else {
                handleNotification(` PC${getPcNumberFromIp(ip)} IMEI Updated!`);
            }

            // Clear the editedData state
            setEditedData({});

            setShowPopup(true);
            setTimeout(() => {
                setFadeOut(true);
            }, 2000);
            setTimeout(() => {
                setFadeOut(false);
                setShowPopup(false);
            }, 3000);
            setLoading(false);

            // Refetch data after submitting
            fetchData();

        } catch (error) {
            setLoading(false);
            console.log(error);
        }
    };







    const fetchSlotsData = async (ip, accessToken) => {
        try {
            const response = await axios.post(`https://frek.cc/proxy/${ip}:8851/port/query`, {
                bool: false,
                pageSize: 1,
                size: 99999999,
                ascs: [],
                descs: []
            }, {
                headers: { "x-access-token": accessToken }
            });

            return response.data.data.data;
        } catch (error) {
            console.error('Error:', error);
            throw error;
        }
    };


    const [slotsData, setSlotsData] = useState([]);
    useEffect(() => {
        // Assuming you have the access token stored in a state or a variable named `accessToken`
        fetchSlotsData(ip, accessToken).then(data => {
            setSlotsData(data);
        });
    }, [ip, accessToken]);








    const generateIMEI = () => {
        let rbi = ["01", "10", "30", "33", "35", "44", "45", "49", "50", "51", "52", "53", "54", "86", "91", "98", "99"];
        let arr = rbi[Math.floor(Math.random() * rbi.length)].split("");
        let pos = 2;
        let str = [Number(arr[0]), Number(arr[1])];
        let sum = 0;
        let final_digit = 0;
        let len_offset = 0;
        let len = 15;

        while (pos < len - 1) {
            str[pos++] = Math.floor(Math.random() * 10) % 10;
        }

        len_offset = (len + 1) % 2;

        for (pos = 0; pos < len - 1; pos++) {
            if ((pos + len_offset) % 2) {
                let t = str[pos] * 2;
                if (t > 9) {
                    t -= 9;
                }
                sum += t;
            } else {
                sum += str[pos];
            }
        }

        final_digit = (10 - (sum % 10)) % 10;
        str[len - 1] = final_digit;

        return str.join('');
    };


    const handleFillIMEI = (index) => {
        setEditedData(prevState => ({
            ...prevState,
            [index]: { port: dataz[index].port, imei: generateIMEI() },
        }));
    };

    const handleFillAllIMEI = () => {
        dataz.forEach((item, index) => {
            const matchingSlot = slotsData.find(slotItem => slotItem.port === item.port);
            if (matchingSlot) { // Check if the state is "off"
                handleFillIMEI(index);
            }
            handleNotification(` IMEI FILLED !`);
        });
    };



    const handleNotification = (message, severity = 'success') => {
        showNotification(message, severity);
      };




    return (
        <div>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', paddingTop: '10px' }}>
              
            </div>


            {(
                <div>


                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5px', justifyContent: 'left' }}>




                        <TableContainer
                            component={Paper}
                            style={{ maxWidth: '600px' }}
                            sx={{
                                backgroundColor: "#b0b0b0",
                                width: '100%',
                                maxWidth: '100%',
                                overflowX: 'auto'
                            }}
                        >
                            <Box
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    width: '100%',
                                    py: 0.5
                                }}
                            >
                                <Stack direction="row" spacing={0.5}>
                                    <Tooltip title="Fill all IMEI">
                                        <span>
                                            <IconButton
                                                size="small"
                                                color="secondary"
                                                onClick={handleFillAllIMEI}
                                                sx={{ backgroundColor: 'rgba(156, 39, 176, 0.1)', p: 0.5 }}
                                            >
                                                <AutoFixHighIcon fontSize="small" />
                                            </IconButton>
                                        </span>
                                    </Tooltip>

                                    <Tooltip title={loading ? "Updating IMEI..." : "Save IMEI changes"}>
                                        <span>
                                            <IconButton
                                                size="small"
                                                color="primary"
                                                onClick={handleSubmitz}
                                                disabled={loading}
                                                sx={{ backgroundColor: 'rgba(25, 118, 210, 0.1)', p: 0.5 }}
                                            >
                                                {loading ? <CircularProgress size={14} /> : <SaveIcon fontSize="small" />}
                                            </IconButton>
                                        </span>
                                    </Tooltip>
                                </Stack>
                            </Box>
                          
                        </TableContainer>

                    </div>

                </div>
            )}
        </div>



    );
}

export default ImeiConfig;
